jQuery($ => {
	const $featuredArticles = $('section.featured-article');
	if ($featuredArticles.length) {
		$featuredArticles.each((_, fa) => {
			const $fa = $(fa);
			const $decor = $fa.children('.decor-top-right-2');
			if ($decor.length) {
				$decor.appendTo($fa.find('.image-wrapper'));
			}
		});
	}
});
